import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/es5/locale/es';
import GoogleIcon from '@/components/icons/GoogleIcon';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#3369FF',
        secondary: '#222143',
        accent: '#82B1FF',
        error: '#F93A7D',
        info: '#2196F3',
        success: '#00ACC1',
        warning: '#FFC107',
        anchor: '#3369FF',
        background: '#222143'
      },
      dark: {
        primary: '#222143',
        secondary: '#3369FF',
        accent: '#82B1FF',
        error: '#F93A7D',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#222143'
      }
    }
  },
  icons: {
    values: {
      google: {
        component: GoogleIcon
      }
    }
  },
  lang: {
    locales: { es },
    current: 'es'
  }
});
